import React from 'react'
import MyChart from './Chart'

const Charts = () => {
  return (
    <div  className='grid grid-cols-2 gap-[400px] gap-x-[400px] lg:px-[310px] lg:mt-5 sm:px-6 sm:mt-5 '>
        <div className='border rounded-lg shadow-xl min-h-[200px] w-[800px] px-32'>
        {/**<p className='mt-32 ml-52 font-semibold text-4xl text-purple-700  '>charts</p>*/}
        <MyChart/>
        </div>
        <div className='border rounded-lg shadow-md min-h-[200px] w-[500px]'>
          <h2 className='text-black font-medium text-base m-5'>Traffic Sources</h2>
         
      <div className='px-12 pb-10'>
      <div >
  <div className="mb-6 flex justify-between items-center">
    <h3 className="text-sm font-semibold text-gray-800 dark:text-white">Progress title</h3>
    <span className="text-sm text-gray-800 dark:text-white">25%</span>
  </div>
  <div className="flex w-full h-2 bg-gray-200 rounded-full overflow-hidden dark:bg-gray-700" role="progressbar" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
    <div className="flex flex-col justify-center rounded-full overflow-hidden bg-purple-600 text-xs text-white text-center whitespace-nowrap transition duration-500 dark:bg-purple-500" style={{width:" 25%"}} ></div>
  </div>
</div>

<div>
  <div className="mb-6 flex justify-between items-center">
    <h3 className="text-sm font-semibold text-gray-800 dark:text-white">Progress title</h3>
    <span className="text-sm text-gray-800 dark:text-white">50%</span>
  </div>
  <div className="flex w-full h-2 bg-gray-200 rounded-full overflow-hidden dark:bg-gray-700" role="progressbar" aria-valuenow="50" aria-valuemin="0" aria-valuemax="100">
    <div className="flex flex-col justify-center rounded-full overflow-hidden bg-purple-600 text-xs text-white text-center whitespace-nowrap transition duration-500 dark:bg-purple-500" style={{width:" 50%"}} ></div>
  </div>
</div>

<div>
  <div className="mb-6 flex justify-between items-center">
    <h3 className="text-sm font-semibold text-gray-800 dark:text-white">Progress title</h3>
    <span className="text-sm text-gray-800 dark:text-white">75%</span>
  </div>
  <div className="flex w-full h-2 bg-gray-200 rounded-full overflow-hidden dark:bg-gray-700" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100">
    <div className="flex flex-col justify-center rounded-full overflow-hidden bg-purple-600 text-xs text-white text-center whitespace-nowrap transition duration-500 dark:bg-purple-500" style={{width:" 75%"}} ></div>
  </div>
</div>

<div>
  <div className="mb-6 flex justify-between items-center">
    <h3 className="text-sm font-semibold text-gray-800 dark:text-white">Progress title</h3>
    <span className="text-sm text-gray-800 dark:text-white">100%</span>
  </div>
  <div className="flex w-full h-2 bg-gray-200 rounded-full overflow-hidden dark:bg-gray-700" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100">
    <div className="flex flex-col justify-center rounded-full overflow-hidden bg-purple-600 text-xs text-white text-center whitespace-nowrap transition duration-500 dark:bg-purple-500" style={{width:" 100%"}} ></div>
  </div>
</div> 
      </div>

        </div>
    </div>
  )
}

export default Charts